import { render, staticRenderFns } from "./NewAccountSettingLimit.vue?vue&type=template&id=b56276d0&"
import script from "./NewAccountSettingLimit.vue?vue&type=script&lang=js&"
export * from "./NewAccountSettingLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports